import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const MailOpenIcon = ({ className, fill='#2e2e2e' }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <g clip-path="url(#clip0_177531_26061)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.4163 8.37562L12.4163 2.37562C12.1642 2.20748 11.8358 2.20748 11.5837 2.37562L2.58375 8.37562C2.37509 8.51484 2.24984 8.74916 2.25 9V18.75C2.25 19.5784 2.92157 20.25 3.75 20.25H20.25C21.0784 20.25 21.75 19.5784 21.75 18.75V9C21.7502 8.74916 21.6249 8.51484 21.4163 8.37562ZM9.0675 14.25L3.75 18V10.4559L9.0675 14.25ZM10.6022 15H13.3978L18.7069 18.75H5.29313L10.6022 15ZM14.9325 14.25L20.25 10.4559V18L14.9325 14.25ZM12 3.90094L19.6791 9.02063L13.3978 13.5H10.6041L4.32281 9.02063L12 3.90094Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_177531_26061">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MailOpenIcon;
